import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { loginRequest, apiRequest } from '../config/authConfig';
import { apiService } from '../services/apiService';

export const useAuthentication = () => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const login = () => {
    
    instance.loginPopup(loginRequest).catch((e) => {
      console.error('Login failed:', e);
    });
   // instance.loginRedirect(loginRequest).catch((e) => {
   //   console.error('Login failed:', e);
    //});
  };

  const logout = () => {
    instance.logoutPopup({
      postLogoutRedirectUri: '/',
      mainWindowRedirectUri: '/',
    }).catch((e) => {
      console.error('Logout failed:', e);
    });
  };

  const getActiveAccount = () => {
    return instance.getActiveAccount() || accounts[0] || null;
  };

  const getUserName = () => {
    const account = getActiveAccount();
    return account?.name || account?.username || 'User';
  };

  const getUserEmail = () => {
    const account = getActiveAccount();
    return account?.username || '';
  };

  const getUsers = async () => {
     try {
      const token = await getAccessToken(true); // Use API scopes for your client ID audience
      if (!token) {
        console.error('No access token available');
        return null;
      }

      return await apiService.authenticatedRequest('/api/Users/exists/postalguy', token);
    } catch (error) {
      console.error('Failed to fetch users:', error);
      return null;
    }
  };

  const getAccessToken = async (forApi: boolean = true) => {
    try {
      const account = getActiveAccount();
      if (!account) return null;

      // Use API scopes to get a token with your client ID as audience
      const requestConfig = forApi ? apiRequest : loginRequest;

      const response = await instance.acquireTokenSilent({
        ...requestConfig,
        account: account,
      });
      
      return response.accessToken;
    } catch (error) {
      console.error('Failed to acquire token:', error);
      
      // If silent token acquisition fails, try interactive
      try {
        const requestConfig = forApi ? apiRequest : loginRequest;
        const response = await instance.acquireTokenPopup(requestConfig);
        return response.accessToken;
      } catch (interactiveError) {
        console.error('Interactive token acquisition failed:', interactiveError);
        return null;
      }
    }
  };

  const makeAuthenticatedApiCall = async <T>(endpoint: string, options?: RequestInit): Promise<T | null> => {
    try {
      const token = await getAccessToken(true); // Use API scopes for your client ID audience
      if (!token) {
        console.error('No access token available');
        return null;
      }

      return await apiService.authenticatedRequest<T>(endpoint, token, options);
    } catch (error) {
      console.error('Authenticated API call failed:', error);
      return null;
    }
  };

  const debugToken = async () => {
    try {
      const token = await getAccessToken(true);
      if (token) {
        // Decode the JWT to see its contents (client-side decoding for debugging)
        const payload = JSON.parse(atob(token.split('.')[1]));
        console.log('Token payload:', payload);
        console.log('Audience (aud):', payload.aud);
        console.log('Expected client ID:', import.meta.env.VITE_AZURE_CLIENT_ID);
        return payload;
      }
    } catch (error) {
      console.error('Failed to debug token:', error);
    }
    return null;
  };

  return {
    isAuthenticated,
    login,
    logout,
    getActiveAccount,
    getUsers,
    getUserName,
    getUserEmail,
    getAccessToken,
    makeAuthenticatedApiCall,
    debugToken,
    accounts,
  };
};
